(ns admin.router.routes
  (:require [kyber.feature-flags :as ff]))

(def activity-build-routes
  {"/settings"
   :activity-settings

   "/overview"
   :activity-overview

   "/moments"
   :activity-moments

   "/resources"
   :activity-resources

   "/advanced"
   :activity-advanced

   "/boosts"
   :activity-boosts

   "/boosts/new"
   :activity-boost-step-workflow

   ["/boosts/" :boost-uuid "/edit"]
   :edit-activity-boost

   ["/boosts/" :boost-uuid "/edit-questions/" :question-step]
   :edit-activity-boost-questionnaire

   ["/evaluation/" :question-step]
   :activity-evaluation

   ["/assessments/" :question-step]
   :activity-assessments})

(def activity-detail-route-redirects
  {"/edit"
   :redirect-activity-settings

   "/overview"
   :redirect-activity-overview

   "/moments"
   :redirect-activity-moments

   "/resources"
   :redirect-activity-resources

   "/advanced"
   :redirect-activity-advanced

   "/boosts"
   :redirect-activity-boosts

   "/boosts/new"
   :redirect-activity-boost-step-workflow

   ["/boosts/" :boost-uuid "/edit"]
   :redirect-edit-activity-boost

   ["/boosts/" :boost-uuid "/edit-questions/" :question-step]
   :redirect-edit-activity-boost-questionnaire

   ["/evaluation/" :question-step]
   :redirect-activity-evaluation

   ["/assessments/" :question-step]
   :redirect-activity-assessments})

(def activity-performance-routes
  {"/overview" :performance-overview
   "/participation" :performance-participation
   "/readiness" :performance-readiness
   "/effectiveness" :performance-effectiveness
   "/engagement" :performance-engagement})

(def activity-dashboard-routes
  {"" :dashboard-list
   ["/" :dashboard-key] {"" :dashboard
                         ["/" :child1] :dashboard
                         ["/" :child1 "/" :child2] :dashboard
                         ["/" :child1 "/" :child2 "/" :child3] :dashboard}})

(def activity-report-routes
  {"/line-manager" :reports-line-manager
   "/director-report" :reports-director})

(def learner-reporting-routes
  {"" :learner-reports-activity
   ["/learner/" :learner-uuid] :learner-reports-activity-learner})

(def activity-routes
  {"/details" activity-detail-route-redirects
   "/build" activity-build-routes
   "/performance" activity-performance-routes
   "/dashboards" activity-dashboard-routes
   "/reports" activity-report-routes
   "/learner-report" learner-reporting-routes})

(def curriculum-build-routes
  (cond-> {"/activities" :curriculum-activities
           "/settings" :curriculum-settings}
    (ff/feature-enabled? :curriculum-pre-reg)
    (assoc "/learners" :curriculum-learners)))

(def curriculum-demo-routes
  {"/feasibility" :curriculum-demo-feasibility
   "/reports" :curriculum-demo-curriculum-report
   "/reports/sites-report" :curriculum-demo-sites-report
   "/reports/roles-report" :curriculum-demo-roles-report
   "/reports/learner-report" :curriculum-demo-learner-report})

;;Temporary alternate demo routes
(def curriculum-alternate-demo-routes
  {"/feasibility" :curriculum-alternate-demo-feasibility
   "/reports" :curriculum-alternate-demo-curriculum-report
   "/reports/sites-report" :curriculum-alternate-demo-sites-report
   "/reports/roles-report" :curriculum-alternate-demo-roles-report
   "/reports/learner-report" :curriculum-alternate-demo-learner-report})

;;Temporary alternate demo routes
(def curriculum-alternate-demo-routes-v2
  {"/feasibility" :curriculum-alternate-v2-demo-feasibility
   "/reports" :curriculum-alternate-v2-demo-curriculum-report
   "/reports/sites-report" :curriculum-alternate-v2-demo-sites-report
   "/reports/roles-report" :curriculum-alternate-v2-demo-roles-report
   "/reports/learner-report" :curriculum-alternate-v2-demo-learner-report})

(def curriculum-reports-routes
  (cond-> {}
    (ff/feature-enabled? :learner-table)
    (assoc "" :curriculum-reports)
    (ff/feature-enabled? :learner-report)
    (assoc "/learner" :curriculum-learner-report)))

(def curriculum-routes
  (cond-> {"" :redirect-curriculum-activities
           "/edit" :redirect-curriculum-settings
           "/build" curriculum-build-routes
           "/demo" curriculum-demo-routes
           "/alternate-demo" curriculum-alternate-demo-routes
           "/alternate-demo-v2" curriculum-alternate-demo-routes-v2
           "/new-document-activity" :new-document-activity
           "/new-video-activity" :new-video-activity
           "/learner-reports" :curriculum-learner-reports-index
           ["/activity/" :activity-uuid] activity-routes}
    (ff/some-feature-enabled? #{:learner-table :learner-report})
    (assoc "/reports" curriculum-reports-routes)))

(def routes
  ["/"
   {"privacy-policy" :external-redirect-privacy-policy
    "terms-and-conditions" :terms-and-conditions

    "admin"
    {"" :curriculum-selection
     "/sign-in" :admin-sign-in
     "/question-bank" :question-bank
     "/feature-flags" :feature-flags
     "/users" :user-management
     "/content-settings" :content-settings
     "/new-curriculum" :new-curriculum
     "/identity-provider-management" :identity-provider-management
     ["/curriculum/" :curriculum-uuid] curriculum-routes}}])
